import { render, staticRenderFns } from "./SeleccionRiesgosAntisoborno.vue?vue&type=template&id=95646104&"
import script from "./SeleccionRiesgosAntisoborno.vue?vue&type=script&lang=js&"
export * from "./SeleccionRiesgosAntisoborno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports